"use client";

import { VolumeDown, VolumeOff, VolumeUp } from "@opensea/ui-kit/icons";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { useShallow } from "zustand/react/shallow";
import { trackAction } from "@/lib/integrations/datadog";
export const defaultVolume = "low";
export const VOLUME_PREFERENCE_KEY = "volumePreference";
export let Sound = /*#__PURE__*/function (Sound) {
  Sound["AcceptOfferSuccess"] = "/sounds/320777-accept-offer-success.mp3";
  Sound["AccountSettingsSave"] = "/sounds/702168-account-settings-save.mp3";
  Sound["BuySuccess"] = "/sounds/320652-buy-success.mp3";
  Sound["CancelOrderSuccess"] = "/sounds/322895-cancel-order-success.mp3";
  Sound["ClaimReward"] = "/sounds/353232-claim-reward.mp3";
  Sound["CreateOfferSuccess"] = "/sounds/322897-create-offer-success.mp3";
  Sound["CreatorStudioSave"] = "/sounds/320181-creator-studio-save.mp3";
  Sound["CreatorStudioPublish"] = "/sounds/80921-creator-studio-publish.mp3";
  Sound["CurrencyPositionsLoaded"] = "/sounds/531509-positions-loaded.mp3";
  Sound["ListSuccess"] = "/sounds/320775-list-success.mp3";
  Sound["Mint"] = "/sounds/342751-mint.mp3";
  Sound["Notification"] = "/sounds/342755-notification.mp3";
  Sound["OnboardWelcome"] = "/sounds/781199-onboard-welcome.mp3";
  Sound["OpenTreasureChest"] = "/sounds/662458-open-treasure-chest.mp3";
  Sound["ScoreIncrease"] = "/sounds/320657-xp-levelup.mp3";
  Sound["Select"] = "/sounds/171697-select.mp3";
  Sound["SendCurrencySuccess"] = "/sounds/322930-send-currency-success.mp3";
  Sound["SendMessage"] = "/sounds/104945-send-message.mp3";
  Sound["SwapSuccess"] = "/sounds/342750-swap-success.mp3";
  Sound["TransferNft"] = "/sounds/232009-transfer-nft.mp3";
  Sound["WatchlistAdd"] = "/sounds/232004-watchlist-add.mp3";
  Sound["WatchlistRemove"] = "/sounds/232006-watchlist-remove.mp3";
  return Sound;
}({});
export const useVolumeStore = create()(persist((set, get) => ({
  volume: defaultVolume,
  setVolume: volume => {
    set({
      volume
    });
    void trackAction("switch volume", {
      value: volume
    });
  },
  toggleVolume: () => {
    const currentVolume = get().volume;
    let nextVolume;
    if (currentVolume === "high") {
      nextVolume = "off";
    } else if (currentVolume === "off") {
      nextVolume = "low";
    } else {
      nextVolume = "high";
    }
    set({
      volume: nextVolume
    });
    void trackAction("switch volume", {
      value: nextVolume
    });
  }
}), {
  name: VOLUME_PREFERENCE_KEY
}));

// Backward compatibility hook that matches the original interface
export const useVolume = () => {
  return useVolumeStore(useShallow(_temp));
};
export function getVolumeNumber(volume) {
  if (volume === "off") {
    return 0;
  }
  if (volume === "low") {
    return 0.15;
  }
  return 0.4;
}
export function getVolumeIcon(volume) {
  if (volume === "off") {
    return VolumeOff;
  }
  if (volume === "low") {
    return VolumeDown;
  }
  return VolumeUp;
}
export function soundOpts(volume) {
  return {
    volume: getVolumeNumber(volume)
  };
}
function _temp(state) {
  return {
    volume: state.volume,
    setVolume: state.setVolume
  };
}